import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-success-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, TranslateModule],
  template: `
    <p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '600px' }" [draggable]="false" 
              [resizable]="false" (visibleChange)="onVisibleChange()">
      <div class="text-center">
        <div class="animated-check-circle"></div>
        <p class="title">{{ resolvedTitle }}</p>
        <p class="text">{{ resolvedMessage }}</p>
        <button class="btn btn-action mt-4" (click)="onClose()">{{ 'COMMON.OK' | translate }}</button>
      </div>
    </p-dialog>
  `,
  styles: [`
    .title {
      font-weight: 500;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;
      margin: 1rem 0 0.5rem 0;
    }
    
    .text {
      font-size: 1rem;
      color: #666;
      margin-bottom: 1rem;
    }
    
    .btn {
      padding: 0.75rem 2rem;
      border-radius: 0.5rem;
      font-weight: 500;
      cursor: pointer;
      border: none;
      transition: all 0.3s ease;
    }
    
    .btn-action {
      background-color: #00377B;
      color: white;
    }
    
    .btn-action:hover {
       background-color: #00377B;
    }
     
    .animated-check-circle::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 30px;
      height: 20px;
      border: 4px solid white;
      border-top: none;
      border-right: none;
      transform: translate(-50%, -60%) rotate(-45deg);
    }
    
    @keyframes checkmark {
      0% {
        transform: scale(0);
        opacity: 0;
      }
      50% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }
  `]
})
export class SuccessDialogComponent {
  @Input() visible: boolean = false;
  @Input() title: string = '';
  @Input() message: string = '';
  
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<void>();

  constructor(private translate: TranslateService) {}

  get resolvedTitle(): string {
    return this.title || this.translate.instant('COMMON.SUCCESS');
  }

  get resolvedMessage(): string {
    return this.message || this.translate.instant('COMMON.MSG_OPERATION_COMPLETED_SUCCESSFULLY');
  }

  onVisibleChange() {
    this.visibleChange.emit(this.visible);
  }

  onClose() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.close.emit();
  }
}
